import { createSlice } from "@reduxjs/toolkit"

const loaderSlice = createSlice({
  name: "loader",
  initialState: {
    isLoading: false,
  },
  reducers: {
    changeloaderState: (state, action) => {
      state.isLoading = action.payload
    },
  },
})

export default loaderSlice
export const { changeloaderState } = loaderSlice.actions
